export default function LoadingIndicator() {
  return (
    <div className="Load-More-Container" role="status" aria-live="polite">
      <button className="Load-More-Button" type="button" disabled>
        Loading... <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
      </button>
    </div>
  );
}
